export function defer() {

	const obj = {},
		retval = new Promise( ( resolve, reject ) => {
			Object.assign( obj, { resolve, reject } );
		} );
	return Object.assign( retval, obj );
}
export const domReady = ( () => {
	return SystemJS.import( 'jquery' )
		.then( $ => new Promise( resolve => { $( resolve ); } ) );
} )();

export function wait( milliseconds = 0 ) {
	const obj = {},
		retval = new Promise( ( resolve, reject ) => {
			setTimeout( () => { resolve(); }, milliseconds );
			Object.assign( obj, { cancel() {
				reject( new Error( 'Cancelled' ) );
			} } );
		} );
	return Object.assign( retval, obj );
}

export function importModules( ...moduleNames ) {
	return Promise.all( moduleNames.map( n => SystemJS.import( n ) ) );
}

export function timeout( p, millis ) {
	return Promise.race( [
		Promise.resolve( p ),
		new Promise( ( resolve, reject )  => {
			setTimeout( () => { reject( new Error( 'Timeout expired' ) ); }, millis );
		} )
	] );
}
